let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iWr9A")).then(() => parcelRequire('j4GeI'));